import type { Provider } from '@angular/core';

import type { IPageSetupService } from './page-setup.models';
import { PageSetupService } from './page-setup.service';

export function providePageSetupBrowserService(): Provider {
	return {
		provide: PageSetupService,
		useValue: <IPageSetupService>{
			initialize: () => null,
		},
	};
}
